import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "../images/ipark-logo.png";
import logo2 from "../images/logo2.png";
import "../styles/login.css";
import Navbar from "../components/NavbarHome";

// REDUX
import { connect } from "react-redux";
import { loginUser } from "../redux/actions/userActions";

// bootstrap
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

// MUI
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
  usernameTextField: {
    marginTop: "20px"
  },
  passwordTextField: {
    marginBottom: "20px"
  },
  submitButton: {
    color: "#457ed2",
    border: "1px solid #457ed2"
  }
};

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      errors: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ui.errors) {
      this.setState({ errors: nextProps.ui.errors });
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    const userCredentials = {
      email: this.state.email,
      password: this.state.password
    };

    this.props.loginUser(userCredentials, this.props.history);
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleEnter = e => {
    e.preventDefault();
    if (e.keyCode === 13) {
      this.handleSubmit(e);
    }
  };

  render() {
    const {
      ui: { loading }
    } = this.props;
    const { errors } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <Navbar />
        <div className="container login-container">
          <div className="row text-center justify-content-center m-3">
            <div className="col-lg-5 border left-div">
              <form>
                <img src={logo} alt="" className="logo" />
                <div>
                  <TextField
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Enter email here"
                    label="Email"
                    size="small"
                    className={classes.usernameTextField}
                    value={this.state.email}
                    onChange={this.handleChange}
                    onKeyUp={this.handleEnter}
                    helperText={errors.email}
                    error={errors.email ? true : false}
                    disabled={loading}
                    inputProps={{ style: { textAlign: "center" } }}
                  />
                </div>
                <div>
                  <TextField
                    id="password"
                    type="password"
                    name="password"
                    label="Password"
                    placeholder="Enter password here"
                    value={this.state.password}
                    className={classes.passwordTextField}
                    onChange={this.handleChange}
                    onKeyUp={this.handleEnter}
                    helperText={errors.password}
                    error={errors.password ? true : false}
                    disabled={loading}
                    inputProps={{ style: { textAlign: "center" } }}
                    floatingLabelShrinkStyle={{ textAlign: "center" }}
                  />
                </div>
                <hr />
                {errors.general && (
                  <Typography variant="body2">{errors.general}</Typography>
                )}
                <div className="button-login-div">
                  <Button
                    variant="outline-secondary"
                    className={classes.submitButton}
                    type="submit"
                    name="loginButton"
                    onClick={this.handleSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner
                        className="spinner"
                        animation="border"
                        role="status"
                        size="sm"
                      />
                    ) : (
                      "Login"
                    )}
                  </Button>
                </div>
                <small>
                  {" "}
                  Don't have an account? Sign up{" "}
                  <Link to="/signup"> here </Link>{" "}
                </small>
              </form>
            </div>
            <div className="col-lg-5 rightDiv">
              <div className="right-div-content">
                <img src={logo2} alt="iPark" className="logo2" />
                <h6 className="h6">
                  Online Web Application for Parking Assistance <br /> and
                  Reservation
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  ui: state.ui
});

const mapActionsToProps = {
  loginUser
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(Login));
